module.exports = __webpack_public_path__ + "img/perks_F Ticket Exchange Program.845fa495.jpg";